import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from 'react-i18next';
import "./investorpage.css"

const InvestorPage = () => {
    const { t } = useTranslation();
    const topRef = useRef();
    const midRef = useRef();

    const [isTopVisible, setIsTopVisible] = useState(false);
    const [isMidVisible, setIsMidVisible] = useState(false);

    useEffect(() => {
        const currentTopRef = topRef.current;
        const currentMidRef = midRef.current;

        const topObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsTopVisible(true);
                    topObserver.unobserve(entry.target);
                }
            });
        });

        const midObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    setIsMidVisible(true);
                    midObserver.unobserve(entry.target);
                }
            });
        });

        if (currentTopRef) {
            topObserver.observe(currentTopRef);
        }

        if (currentMidRef) {
            midObserver.observe(currentMidRef);
        }

        return () => {
            if (currentTopRef) {
                topObserver.unobserve(currentTopRef);
            }

            if (currentMidRef) {
                midObserver.unobserve(currentMidRef);
            }
        };
    }, []);

    return (
        <div className='investor-main-container'>

            <div className={`investor-top-container relative ${isTopVisible ? "fade-in" : ""}`} ref={topRef}>
                <div className="investor-header-content">
                    <h1 className="homepage-title1 mb-0">{t('investorPage.header.title')}</h1>
                </div>
            </div>

            <div className={`investor-bottom-container ${isMidVisible ? "fade-in" : ""}`} ref={midRef}>

                <div className='md:grid grid-cols-2 gap-12 relative z-2'>
                    <div className=''>
                        <div className='investor-img2 z-4 relative'></div>
                    </div>
                    <div className="py-6">
                        <h1 className='homepage-title2'>{t('investorPage.intro.title')}</h1>
                        <p className='homepage-text2 mb-4'>{t('investorPage.intro.desc1')}</p>
                        <p className='homepage-text2 mb-0'>{t('investorPage.intro.desc2')}</p>
                    </div>
                </div>

                <div className="md:px-[10%] pt-16">
                    <div>
                        <h2 className="homepage-title3">{t('investorPage.explore.title')}</h2>
                        <ul className="homepage-text2 list-disc pl-8">
                            <li>{t('investorPage.explore.list.item1')}</li>
                            <li>{t('investorPage.explore.list.item2')}</li>
                            <li>{t('investorPage.explore.list.item3')}</li>
                            <li>{t('investorPage.explore.list.item4')}</li>
                        </ul>
                        <hr className="my-10" />
                    </div>
                    <div>
                        <h2 className="homepage-title3">{t('investorPage.examples.title')}</h2>
                        <ul className="homepage-text2 list-disc pl-8">
                            <li>{t('investorPage.examples.list.item1')}</li>
                            <li>{t('investorPage.examples.list.item2')}</li>
                            <li>{t('investorPage.examples.list.item3')}</li>
                            <li>{t('investorPage.examples.list.item4')}</li>
                        </ul>
                        <hr className="my-10" />
                    </div>

                    <div>
                        <h2 className="homepage-title3">{t('investorPage.sectors.title')}</h2>
                        <ul className="homepage-text2 list-disc pl-8">
                            <li>{t('investorPage.sectors.list.item1')}</li>
                            <li>{t('investorPage.sectors.list.item2')}</li>
                            <li>{t('investorPage.sectors.list.item3')}</li>
                            <li>{t('investorPage.sectors.list.item4')}</li>
                            <li>{t('investorPage.sectors.list.item5')}</li>
                        </ul>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default InvestorPage;